<template>
  <div class="WEB-Portal index-portale" v-if="isToken">
    <header-app @showMessages="changeShowMessages" :counterNuovi="counterNuovi" :counterBacheca="counterBacheca"></header-app>
    <div class="WEB-page">
      <nav-left v-if="showNavBar" :height="navBarHeight" class="menu"></nav-left>
      <div :style="{ width: contentWidth + 'px'}" class="box-centrale">
        <!--<div class="row row-custom">
          <div class="titolo-app col-lg-24 no-padding">
            <span class="titolo-bold hidden-xs">HOME PAGE</span>
          </div>
        </div>-->
        <keep-alive>
        <router-view @closeMessages="closeMessages" class="contenuto col-xs-24 no-padding"
                     :showMessages="showMessages" :contenitoreHeight="contenitoreHeight - 85"></router-view>
        </keep-alive>
        <messages v-show="showMessages.val" @changeCounterNuovi="changeCounterNuovi" @changeCounterBacheca="changeCounterBacheca"
                :showMessages="showMessages" :height="messagesHeight" @closeMessages="closeMessages" @showMessages="changeShowMessages"></messages>
      </div>
    </div>

    <el-dialog class="modalMessaggiBlock"
               custom-class="custom-dialog offset-xl-5 col-xl-14 offset-lg-4 col-lg-16 offset-md-2 col-md-20 offset-0 col-24"
               :append-to-body="true" key="dialog"
               :visible.sync="showModal"
               :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">

      <span slot="title">
        {{ $t('indexPortale.messaggi').toUpperCase() }}
      </span>

      <div class="row row-custom">
        <div class="col-8 no-padding elenco-messaggi">
          <el-card class="col-24" v-for="(item, index) in messaggiBlock"
                    :key="item.id" shadow="never"
                    :class="{ selected: (messaggio.id === item.id), important: isImportant(item) }" @click.native="selectMessage(item, index)">
            <div class="testata col-24">
              <div class="titolo">
                {{ item.titolo.toUpperCase() }}
              </div>
              <div class="priorita" v-if="(item.priorita === '1')">
                <icon name="riv-preferitiFull" scale="0.8"></icon>
              </div>
              <div class="allegati" v-if="(item.allegati.length > 0)">
                <icon name="riv-attach" scale="1"></icon>
              </div>
              <div class="presa-vis" v-if="(item.sePresaVis === 'Y' && item.presaVis === 'N')">
                <icon name="riv-acceptView" scale="1"></icon>
              </div>
               <div class="presa-vis-yes" v-if="(item.sePresaVis === 'Y' && item.presaVis === 'Y')">
                <icon name="riv-read" scale="1"></icon>
              </div>
            </div>
            <!--<div class="col-24 testo " v-html="truncateCardModal(item.testo)"></div>-->
            <div class="col-24 testo truncate" v-html="item.testo"></div>
            <div class="footer col-24 no-padding">
              <div class="data">
                {{ $t('indexPortale')[new Date(item.dataPub.substr(0, 4), parseInt(item.dataPub.substr(5, 2)) - 1, item.dataPub.substr(8, 2)).getDay()] + ', ' + moment(item.dataPub, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
              </div>
              <div class="skip" v-if="(item.seSkip === 'Y')">
                <el-badge :value="'(' + item.numSkip + ')'" class="item" :hidden="(item.numSkip === '' || item.numSkip <= 0 )">
                  <icon name="riv-skip" scale="1"></icon>
                </el-badge>
              </div>
            </div>
          </el-card>
        </div>
        <div class="col-16 area-messaggio">
          <div class="col-24 msg" v-if="showMessaggio">
            <div class="titolo col-24 no-padding">
              {{ messaggio.titolo }}
            </div>
            <div class="data col-24 no-padding">
              {{ (messaggio.data !== '') ? ($t('indexPortale')[new Date(messaggio.dataPub.substr(0, 4), parseInt(messaggio.dataPub.substr(5, 2)) - 1, messaggio.dataPub.substr(8, 2)).getDay()] + ', ' + moment(messaggio.dataPub, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm')) : '' }}
            </div>
            <div class="priorita col-24 no-padding" v-if="(messaggio.priorita === '1')">
              <span class="prior-label">
                {{ $t('indexPortale.priorita.label') + ': ' }}
              </span>
              <span class="prior-value">
                    {{ $t('indexPortale.priorita')[messaggio.priorita].toUpperCase() }}
              </span>
              <span class="prior-icon">
                <icon name="riv-preferitiFull" scale="0.8"></icon>
              </span>
            </div>
            <div class="testo col-24 no-padding" v-html="messaggio.testo"></div>
            <div class="allegati col-24 no-padding" v-if="(messaggio.allegati.length > 0)">
              <div v-for="msg in messaggio.allegati" :key="msg.keyDoc">
                <div class="col-24 no-padding allegato" @click="getAllegato(msg)">
                  <icon class="icona" name="riv-attach" scale="1"></icon>
                  <div class="titolo-allegato">
                    {{ msg.titolo }}
                  </div>
                </div>
              </div>
            </div>
            <div class="messaggio-footer col-24 no-padding" v-if="(messaggio.id !== undefined)">
              
              <el-button v-if="(messaggio.sePresaVis === 'Y' && messaggio.action !== 'Y')" 
               @click.native="setMessaggioService(messaggio, 'P')" class="WEB-button WEB-button-primary">
                {{ $t('indexPortale.presaVisione').toUpperCase() }}
              </el-button>
              <el-button v-if="(messaggio.seSkip === 'Y' && messaggio.action !== 'Y')" 
                @click="setMessaggioService(messaggio, 'S')" class="WEB-button WEB-button-alternative">
                {{ $t('indexPortale.skip', {nskip: messaggio.numSkip}).toUpperCase() }}
              </el-button>

              
              <!--<div class="presa-vis" v-if="(messaggio.sePresaVis === 'Y' && messaggio.action !== 'Y')">
                <icon name="riv-acceptView" scale="2" @click.native="setMessaggioService(messaggio, 'P')"></icon>
              </div>
              <div class="skip" v-if="(messaggio.seSkip === 'Y' && messaggio.action !== 'Y')">
                <el-badge :value="'(' + messaggio.numSkip + ')'" class="item" :hidden="(messaggio.numSkip === '' || messaggio.numSkip <= 0 )">
                  <icon name="riv-skip" scale="2" @click.native="setMessaggioService(messaggio, 'S')"></icon>
                </el-badge>
              </div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="row row-custom">
        <div class="col-24 action">
          <el-button @click="closeDialog()" class="WEB-button WEB-button-primary" :disabled="!enableEndBtn">
              {{ $t('indexPortale.end').toUpperCase() }}
          </el-button>
        </div>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
  import moment from 'moment'
  import HeaderApp from '@/components/HeaderApp'
  import NavLeft from '@/components/NavLeft'
  import Messages from '@/components/Messages'
  import {bus} from './Bus'
  import mixinDownload from "../assets/mixins/downloadDoc.js";

  export default {
    name: 'IndexPortale',
    components: {HeaderApp, NavLeft, Messages},
    mixins: [mixinDownload],
    watch: {
      '$mq.resize': 'setSizes',
      'showMessages.val': function (newVal, oldVal) {
        this.setSizes()
      }
    },
    created: function () {
      if (this.$store.state.manutenzioneFunctionID){
        clearInterval(this.$store.state.manutenzioneFunctionID)
        this.$store.commit('set', { key: 'manutenzioneFunctionID', value: null })
      }
      if (this.$store.state.prossimaManutenzione && this.$store.state.prossimaManutenzione === 'Y') {
        let _this = this
        let valFunction = setInterval(function(){
          _this.$http.get('portale/' + _this.$store.state.country + '/manutenzione', {
            params: {}
          })
            .then(response => {
              if (response.body.rc === 1 && response.body.msg[0].msgId === '1286') {
                sessionStorage.setItem('token', '')
                sessionStorage.removeItem('token')
                sessionStorage.clear()
                clearInterval(_this.$store.state.manutenzioneFunctionID)
                _this.$store.commit('set', { key: 'manutenzioneFunctionID', value: null })
                _this.$router.push({ name: 'Login' })
              }
            })
        }, 600000);
        _this.$store.commit('set', { key: 'manutenzioneFunctionID', value: valFunction })
      }
    },
    mounted: function () {
      /*// this.$router.push({name: 'HomePage'})
      if (sessionStorage.hasOwnProperty('codLang')) {
        this.$root.$i18n.locale = sessionStorage.getItem('codLang')
        //this.codLang = sessionStorage.getItem('codLang')
      } else {
        sessionStorage.setItem('codLang', process.env.codLang)
        this.$root.$i18n.locale = process.env.codLang
      }*/
      if (document.documentElement.clientWidth <= 1280) {
        this.$set(this.showMessages, 'val', false)
      }
      this.setSizes()
      if (sessionStorage.getItem('token')) {
        this.getMessaggiBlock()
        //this.getMessaggiCount()
      }
    },
    i18n: {
      messages: {
        it_IT: {
          indexPortale: {
            nuovi: 'Nuovi',
            letti: 'Letti',
            bacheca: 'Bacheca',
            messaggi: 'Messaggi',
            noMsg: 'Nessun messaggio',
            1: 'Lunedì',
            2: 'Martedì',
            3: 'Mercoledì',
            4: 'Giovedì',
            5: 'Venerdì',
            6: 'Sabato',
            0: 'Domenica',
            leggi: 'Leggi',
            priorita: {
              label: 'Priorità',
              1: 'Alta'
            },
            elimina: 'Elimina',
            scade: 'Scade il',
            ricevuto: 'Ricevuto il',
            presaVisione: 'Presa Visione',
            skip: 'Skip ({nskip})',
            end: 'fine'
          }
        },
        fr_FR: {
          indexPortale: {
            nuovi: 'Nouveau',
            letti: 'Lu',
            bacheca: 'Petites Ann.',
            messaggi: 'Messages',
            noMsg: 'Pas de message',
            1: 'Lundi',
            2: 'Mardi',
            3: 'Mercredi',
            4: 'Jeudi',
            5: 'Vendredi',
            6: 'Sabbat',
            0: 'Dimanche',
            leggi: 'Lire',
            priorita: {
              label: 'Priorité',
              1: 'Haute'
            },
            elimina: 'Éliminer',
            scade: 'Expire le',
            ricevuto: 'Reçu le',
            presaVisione: 'Presa Visione',
            skip: 'Skip ({nskip})',
            end: 'fine'
          }
        },
        es_ES: {
          indexPortale: {
            nuovi: 'Nuevos',
            letti: 'Leidos',
            bacheca: 'Prioritari',
            messaggi: 'Mensajes',
            noMsg: 'Sin mensaje',
            1: 'Lunes',
            2: 'Martes',
            3: 'Miércoles',
            4: 'Jueves',
            5: 'Viernes',
            6: 'Sábado',
            0: 'Domingo',
            leggi: 'Leer',
            priorita: {
              label: 'Prioridad',
              1: 'Alto'
            },
            elimina: 'Eliminar',
            scade: 'Vence el',
            ricevuto: 'Recibido el',
            presaVisione: 'Presa Visione',
            skip: 'Skip ({nskip})',
            end: 'fine'
          }
        },
        de_DE: {
          indexPortale: {
            nuovi: 'Neu',
            letti: 'Gelesen',
            bacheca: 'Schwarzes Brett',
            messaggi: 'Beiträge',
            noMsg: 'Keine nachricht',
            1: 'Montag',
            2: 'Dienstag',
            3: 'Mittwoch',
            4: 'Donnerstag',
            5: 'Freitag',
            6: 'Sabbat',
            0: 'Sonntag',
            leggi: 'Lesen',
            priorita: {
              label: 'Priorität',
              1: 'Hoch'
            },
            elimina: 'Beseitigen',
            scade: 'Läuft am ab',
            ricevuto: 'Eingegangen am',
            presaVisione: 'Presa Visione',
            skip: 'Skip ({nskip})',
            end: 'fine'
          }
        },
        en_GB: {
          indexPortale: {
            nuovi: 'New',
            letti: 'Read',
            bacheca: 'Notice Board',
            messaggi: 'Messages',
            noMsg: 'No messages',
            1: 'Monday',
            2: 'Tuesday',
            3: 'Wednesday',
            4: 'Thursday',
            5: 'Friday',
            6: 'Saturday',
            0: 'Sunday',
            leggi: 'Read',
            priorita: {
              label: 'Priority',
              1: 'High'
            },
            elimina: 'Remove',
            scade: 'Expires',
            ricevuto: 'Received on',
            presaVisione: 'Presa Visione',
            skip: 'Skip ({nskip})',
            end: 'fine'
          }
        }
      }
    },
    data () {
      return {
        moment: moment,
        showMessages: {
          val: false,
          type: 0
        },
        navBarHeight: 0,
        messagesHeight: 0,
        contenitoreHeight: 0,
        contentWidth: 0,
        counterNuovi: 0,
        counterBacheca: 0,
        /*msg: {
          titolo: '',
          dataPub: '',
          dataExp: '',
          testo: '',
          allegati: []
        },*/
        messaggio: {},
        showModal: false,
        showMessaggio: false,
        messaggiBlock: [],
        //messaggiCount: {},
        counterPresaVis: 0,
        messaggiAction: [],
        reloadMessaggi: false
      }
    },
    computed: {
      isToken: function () {
        if (sessionStorage.getItem('token')) {
          return true
        } else {
          this.$router.push({name: 'Login'})
          return false
        }
      },
      showNavBar: function () {
        let EXCLUDED_PATH = ['presenze']
        return this.$route.path.indexOf('/app/presenze') < 0
      },
      enableEndBtn: function () {
        let result = true
        this.messaggiBlock.forEach((item) => {
          //if ((!item.action || item.action !== 'Y')) || (item.presaVis === 'N' && item.seLetto === 'Y')) {
          //if (item.action !== 'Y' && !(item.presaVis === 'N' && item.seLetto === 'Y')) {
          if (item.action !== 'Y') {
           result = false
          }
        })
        return result
      }
    },
    methods: {
      changeCounterNuovi: function (counterNuovi) {
        this.counterNuovi = counterNuovi
      },
      changeCounterBacheca: function (counterBacheca) {
        this.$set(this, 'counterBacheca', counterBacheca)
      },
      formatDate: function (date) {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      },
      setSizes: function () {
        /*if (document.documentElement.clientWidth <= 1650 && this.showMessages.type === 0) {
          this.showMessages.val = false
        }*/
        this.setNavBarHeight()
        this.setMessagesHeight()
        this.setContenitoreHeight()
        this.setContentWidth()
      },
      setNavBarHeight: function () {
        let height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        this.navBarHeight = height - 57
      },
      setMessagesHeight: function () {
        let height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        this.messagesHeight = height - 164
      },
      setContenitoreHeight: function () {
        this.contenitoreHeight = window.innerHeight
      },
      setContentWidth: function () {
        let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        this.$set(this, 'contentWidth', ((this.showMessages.val && this.showMessages.type === 0) ? (width - 495) : (width - 90)))
        /*let width = document.documentElement.clientWidth || document.body.clientWidth
        if (this.showMessages.val && this.showMessages.type === 0) {
          this.contentWidth = width - 565
        } else {
          this.contentWidth = width - 165
        }*/
      },
      changeShowMessages: function () {
        this.$set(this.showMessages, 'val', !this.showMessages.val)
        if (document.documentElement.clientWidth > 1650) {
          this.showMessages.type = 0
        } else {
          this.showMessages.type = 1
        }
      },
      closeMessages: function () {
        this.showMessages.val = false
      },
      getMessaggiBlock: function () {
        setTimeout(() => {
          let msg = {
            titolo: '',
            dataPub: '',
            dataExp: '',
            testo: '',
            allegati: []
          }
          // this.$set(this, 'disabledEndBtn', true)
          this.$set(this, 'showModal', false)
          this.$set(this, 'messaggio', msg)
          // this.$set(this, 'msg', msg)
          this.$set(this, 'showMessaggio', false)
          this.$http.get('communication/' + this.$store.state.country + '/messaggi', {
            params: {
              seBlock: 'Y',
              tipo: '',
              order: ''
            }
          })
            .then(response => {
              if (response.body.rc === 0) {
                if (response.body.data.length > 0) {

                  this.messaggiBlock = response.body.data.map(function(obj) {
                    if (obj.sePresaVis === 'Y' && obj.presaVis === 'Y') {
                      obj.action = 'Y'
                    } else if (obj.sePresaVis === 'N' && obj.seLetto === 'Y') {
                      obj.action = 'Y'
                    } else {
                      obj.action = 'N'
                    }
                    return obj
                  })
                  // this.$set(this, 'messaggiBlock', response.body.data)
                  this.$set(this, 'counterPresaVis', parseInt(response.body.attrib.presaVis))
                  this.$set(this, 'showModal', true)
                  this.$set(this, 'reloadMessaggi', false)
                }
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            })
        }, 200)
      },
      setMessaggioService: function (messaggio, operazione) {
        let data = new FormData()
        data.append('id', messaggio.id)
        data.append('op', operazione)
        this.$http.post('communication/' + this.$store.state.country + '/messaggio', data)
          .then(response => {
            if (response.body.rc === 0) {
              // Messaggio di tipo Presa Visione e Operazione 'P'
              if (messaggio.sePresaVis === 'Y' && operazione === 'P') {
                this.$set(this.messaggiBlock[messaggio.index], 'action', 'Y')
                this.$set(this.messaggiBlock[messaggio.index], 'presaVis', 'Y')
              // Messaggio di tipo In Evidenza e Operazione 'L'
              } else if (messaggio.sePresaVis === 'N' && operazione === 'L') {
                this.$set(this.messaggiBlock[messaggio.index], 'action', 'Y')
                this.$set(this.messaggiBlock[messaggio.index], 'seLetto', 'Y')
              } else if (messaggio.sePresaVis === 'Y' && operazione === 'S') {
                this.$set(this.messaggiBlock[messaggio.index], 'action', 'Y')
                this.$set(this.messaggiBlock[messaggio.index], 'numSkip', parseInt(this.messaggiBlock[messaggio.index].numSkip) - 1)
              }
              this.$set(this, 'reloadMessaggi', true)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      closeDialog: function () {
        let msg = {
          titolo: '',
          dataPub: '',
          dataExp: '',
          testo: '',
          allegati: []
        }
        this.$set(this, 'showModal', false)
        this.$set(this, 'messaggio', msg)
        // this.$set(this, 'msg', msg)
        this.$set(this, 'showMessaggio', false)
        this.$set(this, 'messaggiBlock', [])
        this.$set(this, 'counterPresaVis', 0)
        if (this.reloadMessaggi) {
          // Controllo se ho eseguito un operazione sui messaggi bloccanti e ricalcolo l'elenco dei messaggi Dashboard
          bus.$emit('reloadMessaggi')
        }
      },
      selectMessage: function (item, index) {
        item.index = index
        this.$set(this, 'showMessaggio', true)
        this.$set(this, 'messaggio', item)
        if (item.seLetto === 'N') {
          // Richiamo il servizio di Lettura del documento solo l aprima volta
          this.setMessaggioService(item, 'L')
        }
      },
      isImportant: function (messaggio) {
        if (messaggio.sePresaVis === 'Y' && messaggio.presaVis === 'Y') {
          // Documenti a cui è stata fatta la Presa Visione
          return false
        } else if (messaggio.action === 'Y') {
          // Documenti a cui è stata fatta un operazione
          return false
        } else if (messaggio.sePresaVis === 'N' && messaggio.seLetto === 'Y') {
          // Documenti senza Presa Visione che è già stato letto
          return false
        } else {
          return true
        }
      },
      getMessaggiCount: function () {
        this.$set(this, 'messaggiCount', {})
        this.$http.get('communication/' + this.$store.state.country + '/messaggicount', {})
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'messaggiCount', response.body.data)
              this.$store.commit('set', { key: 'messaggiCount', value: response.body.data })
              //bus.$emit('changeMessaggiCount')
            }
          })
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/WEB-style.less";
  @import "../assets/less/general.less";

  .index-portale {
    .box-centrale {
      //margin-top: 10px;
      float: left;
      margin-left: 15px;
      // border-radius: 5px;
    }
    .set-font();
    height: 100%;
    .menu {
     // padding-top: 15px;
      float: left;
    }
    .language-modal {
      .elemento {
        font-size: 14px;
        margin-top: 5px;
        margin-bottom: 20px;
        .label {
          color: @greenRiva;
        }
        .radio {
          margin-top: 5px;
          color: @greenRiva;
        }
        .value {
          color: #bbbbbb;
        }
        .textarea:focus {
          border: 1px solid @greenRiva;
        }
      }
    }
    .titolo-app {
      padding-left: 5px;
      .set-font(@size: 15px; @color: @greenRiva);
      letter-spacing: 2px;
      overflow: hidden;
      height: 50px;
      line-height: 50px;
      .titolo-bold {
        font-weight: 700;
      }
    }
    .contenitore {
      //padding: 10px 0 10px 0;
      -webkit-box-shadow: 0 0 10px 2px #cecece;
      -moz-box-shadow: 0 0 10px 2px #cecece;
      box-shadow: 0 0 10px 2px #cecece;
      background-color: #ffffff;
      margin: auto;
      overflow-x: hidden;
      text-align: center;
      // border-radius:5px;
    }
  }

  .modalMessaggiBlock {
    &.el-dialog__wrapper {
      .el-dialog {
        .el-dialog__header {
          border-bottom: 0;
          letter-spacing: 2px;
          .set-font(@size: 14px, @family: 'os-semibold', @color: @greenRiva);
        }
        .el-dialog__body {
          .elenco-messaggi {
            height: 490px;
            overflow: auto;
            padding-right: 5px !important;
            .el-card {
              height: 115px;
              float: left;
              margin-bottom: 10px;
              border-radius: 0px;
              padding: 5px 10px !important;
              cursor: pointer;
              .el-card__body {
                padding: 0;
                height: 100%;
                .testata {
                  width: 100%;
                  height: 30px;
                  padding: 0 !important;
                  display: flex;
                  justify-content: space-between;
                  .titolo {
                    width: 80%;
                    .set-font(@family: 'os-semibold', @color: @greenRiva, @size: 14px);
                    text-align: left;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                  .priorita {
                    margin-left: 10px;
                    .fa-icon {
                      color: red;
                    }
                  }
                  .allegati {
                    .fa-icon {
                      color: @greenRiva;
                    }
                  }
                  .presa-vis {
                    .fa-icon {
                      color: @rossoRiva;
                    }
                  }
                  .presa-vis-yes {
                     .fa-icon {
                      color: @greenTick;
                    }
                  }
                  .ricevuto {
                    .set-font(@color: @greenRiva, @size: 10px);
                    font-style: italic;
                    margin-top: 3px;
                  }
                }
                .testo {
                  padding: 0 5px !important;
                  .set-font(@size: 12px; @color: @textTable);
                  text-align: left;
                  height: 55px;
                }
                .footer {
                  display: inline-block;
                  position: absolute;
                  bottom: 6px;
                  left: 0;
                  padding: 0 10px !important;
                  .data {
                    .set-font(@size: 10px);
                    float: left;
                    line-height: 20px;
                    font-style: italic;
                    padding-top: 2px;
                  }
                  .skip {
                    float: right;
                    margin-right: 2px;
                    text-align: right;
                    .el-badge {
                      .fa-icon {
                        color: @oroRiva;
                      }
                      .el-badge__content {
                        border: none;
                        background-color: transparent;
                        color: #CBB385;
                        right: 10px;
                      }
                    }
                  }
                  .el-button {
                    float: right;
                    height: 23px;
                    line-height: 20px;
                    padding: 0 6px;
                    border-color: @oroRiva !important;
                    background-color: @oroRiva !important;
                  }
                }
              }
            }
            & .selected {
              background-color: @hoverTbl;
            }
            & .important {
              border-left: 3px solid @greenRiva;
              .testo {
                .set-font(@color: @textTable, @size: 12px, @family: 'os-bold') !important;
              }
              .footer {
                .data {
                  .set-font(@color: @greenRiva, @size: 10px, @family: 'os-bold') !important;
                  font-style: normal;
                }
              }
            }
          }
          .area-messaggio {
            min-height: 480px;
            padding-left: 20px;
            padding: 0 10px 0 0 !important;
            border:1px solid #EBEEF5;
            .msg {
              height: 100%;
              border-left: 1px solid #e7e7e7;
              padding: 0 0 0 20px !important;
              .titolo {
                .set-font(@color: @greenRiva, @size: 16px, @family: 'os-semibold');
                text-align: left;
                line-height: 20px;
              }
              .data {
                .set-font(@color: @textTable, @size: 12px);
                margin-top: 15px;
                text-align: right;
                font-style: italic;
              }
              .priorita {
                margin-top: 15px;
                text-align: left;
                .prior-label {
                  .set-font(@color: @textTable, @size: 14px, @family: 'os-semibold');
                }
                .prior-value {
                  margin-left: 2px;
                  .set-font(@color: red, @size: 14px, @family: 'os-semibold');
                }
                .prior-icon {
                  .fa-icon {
                    color: red;
                    margin-top: -4px;
                    margin-left: 2px;
                  }
                }
              }
              .testo {
                margin-top: 20px;
                .set-font(@color: @textTable, @size: 13px);
                text-align: justify;
                height: 230px;
                overflow: auto;
                padding-right: 5px !important;
              }
              .allegati {
                margin-top: 10px;
                min-height: 60px;
                max-height: 110px;
                overflow: auto;
                padding-right: 5px !important;
                .allegato {
                  display: inline-block;
                  .icona {
                    width: 10%;
                    float: left;
                    padding-top: 2px;
                  }
                  .titolo-allegato {
                    width: 85%;
                    float: left;
                    .set-font(@color: @greenRiva, @size: 13px);
                    text-align: left;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                }
                .allegato:hover {
                  cursor: pointer;
                }
              }
              .messaggio-footer {
                position: absolute;
                bottom: 0;
                left: 0;
                height: 35px;
                margin-bottom: 5px;
                .el-button {
                  float: right;
                  height: 30px;
                  line-height: 25px;
                  padding: 0 6px;
                }
                .presa-vis {
                  width: 50px;
                  float: right;
                  margin-right: 2px;
                  text-align: center;
                  .fa-icon {
                    color: @rossoRiva;
                  }
                }
                .skip {
                  width: 50px;
                  float: right;
                  margin-right: 2px;
                  text-align: center;
                  .el-badge {
                    .fa-icon {
                      color: @oroRiva;
                    }
                    .el-badge__content {
                      background-color: transparent;
                      color: #CBB385;
                      right: 10px;
                    }
                  }
                }
              }
            }
          }
          .action {
            text-align: right;
            padding: 10px 0 0 0;
          }
        }
      }
    }
  }

  .messagesBlock {
    position: absolute;
    top: 76px;
    right: 0px;
    width: 400px;
    .set-font(@size: 14px);
    .titolo {
      height: 30px;
      text-align: center;
      vertical-align: bottom;
      line-height: 30px;
      .set-font(@color: @greenRiva, @family: 'os-semibold', @size: 16px);
      z-index: 10;
    }
    .tabs-class {
      overflow: auto;
    }
    .el-tabs {
      margin-top: 35px;
      .el-tabs__header {
        margin-bottom: 10px;
        height: 30px;
        position: absolute;
        right: 0px;
        top: 30px;
        width: 100%;
        z-index: 10;
        .el-tabs__nav-wrap {
          border-bottom: 0;
        }
        .el-tabs__nav {
          width: 100%;
          height: 35px;
          background-color: #eef4f9;
          .el-tabs__item {
            width: 33.333%;
            background-color: #eef4f9;
            .barra {
              height: 2px;
            }
            .counter-nuovi {
              .el-badge {
                .el-badge__content {
                  height: 20px;
                  width: 20px;
                  top: 9px;
                  right: -3px;
                  padding: 0;
                  line-height: 16px;
                  .set-font(@color: @white, @size: 10px);
                  letter-spacing: 0;
                  background-color: red;
                }
              }
            }
            .counter-bacheca {
              .el-badge {
                .el-badge__content {
                  height: 20px;
                  width: 20px;
                  top: 9px;
                  right: -3px;
                  padding: 0;
                  line-height: 16px;
                  .set-font(@color: @white, @size: 10px);
                  letter-spacing: 0;
                  background-color: @oroRiva;
                }
              }
            }
          }
        }
      }
      .el-tabs__content {
        overflow: auto;
        .messaggio {
          box-shadow: 1px 1px 12px 1px rgba(0, 0, 0, 0.2);
          transition: 0.3s;
          border-radius: 0;
          width: 97%;
          height: 120px;
          background-color: @white;
          margin: auto;
          margin-bottom: 5px;
          margin-top: 10px;
          .testata {
            width: 100%;
            height: 30px;
            padding: 0 15px;
            display: flex;
            justify-content: space-between;
            .titolo {
              width: 65%;
              .set-font(@family: 'os-semibold', @color: @greenRiva, @size: 14px);
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .priorita {
              margin-top: 2px;
              margin-left: 10px;
              .fa-icon {
                color: red;
              }
            }
            .allegati {
              margin-top: 3px;
              .fa-icon {
                color: @greenRiva;
              }
            }
            .presa-vis {
              margin-top: 3px;
              .fa-icon {
                color: @rossoRiva;
              }
            }
            .ricevuto {
              .set-font(@color: @greenRiva, @size: 11px);
              font-style: italic;
              margin-top: 6px;
            }
          }
          .testo {
            padding: 6px 20px;
            .set-font(@color: @textTable, @size: 12px);
            line-height: 16px;
            height: 60px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .footer {
            width: 100%;
            height: 30px;
            padding: 0 15px;
            display: flex;
            justify-content: space-between;
            .data {
              .set-font(@color: @greenRiva, @size: 11px);
              font-style: italic;
              height: 20px;
              line-height: 20px;
            }
            .el-button {
              height: 23px;
              line-height: 20px;
              padding: 0 7px;
              background-color: @oroRiva !important;
              border-color: @oroRiva !important;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/IndexPortale.vue